export const LOG = "LOG"
export const TOGGLE = "TOGGLE"
